import { render, staticRenderFns } from "./ChildPlanets.vue?vue&type=template&id=13917030&"
import script from "./ChildPlanets.vue?vue&type=script&lang=js&"
export * from "./ChildPlanets.vue?vue&type=script&lang=js&"
import style0 from "./ChildPlanets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports